var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isCancelled)?_c('v-chip',{attrs:{"small":_vm.small,"color":"error"}},[_vm._v(" Cancelled ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }